module.exports = __webpack_public_path__ + "img/group.9092ae19.svg";